import script from "./index.vue?vue&type=script&setup=true&lang=js"
export * from "./index.vue?vue&type=script&setup=true&lang=js"

import "./index.vue?vue&type=style&index=0&id=4e83474e&lang=less&scoped=true"

import exportComponent from "E:\\Voyager_Project\\SourceCode\\Front_End\\dev_version_Voyager\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4e83474e"]])

export default __exports__